module.exports = __webpack_public_path__ + "static/media/alex-normal.55a6aa90.jpg";